import React from "react";
import Box from "@mui/material/Box";
import { SitePage } from "../../../../data/sitePages/SitePage";
import FilterComponent from "../../../ReusableFIlterComponent/FilterComponent";
import { useSearchParams } from "react-router-dom";
import {
  selectSelectedDate,
  selectSelectedOptionGroup,
  selectSelectedOptionStatus,
  setSelectedDate,
  setSelectedOptionGroup,
  setSelectedOptionStatus,
} from "../../../../features/assetManagementSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

// Interface for SitePagesFilterProps
interface SitePagesFilterProps {
  sitePages: SitePage | any;
  editedSelected: any;
  setEditedSelected: any;
  inputValueGroup: string;
  setInputValueGroup: any;
  inputValueEdited: string;
  setInputValueEdited: any;
  inputValueStatus: string;
  setInputValueStatus: any;
  pageOwnerSearchTerm: string;
  selectedPageOwners: string[];
  setPageOwnerSearchTerm: any;
  setSelectedPageOwners: any;
  selectedOptionEdit: string;

  setSelectedOptionEdit: React.Dispatch<React.SetStateAction<string>>;
  setSearchText: any;
  setSelectedOption: any;
  setConfirmedSearchText: any;
}

export default function SitePagesFilter({
  sitePages,
  inputValueGroup,
  setInputValueGroup,
  setInputValueEdited,
  inputValueStatus,
  setInputValueStatus,
  setEditedSelected,
  setPageOwnerSearchTerm,
  setSelectedPageOwners,
  setSelectedOptionEdit,
  setSearchText,
  setSelectedOption,
  setConfirmedSearchText,
}: SitePagesFilterProps) {
  const filteredSitePages = sitePages.filter(
    (pages: any) => pages?.shared_uid !== null && pages?.post_status !== "bin"
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedDate = useSelector(selectSelectedDate);
  const selectedOptionStatus = useSelector(selectSelectedOptionStatus);
  const selectedOptionGroup = useSelector(selectSelectedOptionGroup);
  const dispatch = useDispatch();

  // Clear all filters
  const handleClearFilters = () => {
    setPageOwnerSearchTerm("");
    setSelectedPageOwners([]);
    // setGroupSelected(false);
    setEditedSelected(false);
    // setStatusSelected(false);
    dispatch(setSelectedOptionGroup([]));
    setSelectedOptionEdit("");
    dispatch(setSelectedOptionStatus([]));
    setInputValueGroup("");
    setInputValueEdited("");
    setInputValueStatus("");
    setSearchText("");
    setSelectedOption(null);
    dispatch(setSelectedDate([]));
    setConfirmedSearchText("");

    // Remove only selectedPage while keeping other params
    const newParams = new URLSearchParams(searchParams);
    newParams.delete("filters");
    newParams.delete("pageTitle");
    setSearchParams(newParams);
  };

  const data = filteredSitePages;
  const filterConfig = [
    {
      key: "group",
      label: "Select Page Group",
      searchTerm: inputValueGroup,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setInputValueGroup(e.target.value),
      selectedOption: selectedOptionGroup,
      filterName: "page_group_name",
      data,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedOptionGroup(updatedSelection)),
      count: selectedOptionGroup.length,
      colorSelected: selectedOptionGroup.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "status",
      label: "Select Page Status",
      searchTerm: inputValueStatus,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setInputValueStatus(e.target.value),
      selectedOption: selectedOptionStatus,
      filterName: "post_status",
      data,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedOptionStatus(updatedSelection)),
      count: selectedOptionStatus.length,
      colorSelected: selectedOptionStatus.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: true,
      // valueMapping: { "draft": "A", "pending": "B", "publish": "C" },
    },
    {
      key: "date",
      label: "Select Date Range",
      filterName: "modified_date",
      data,
      selectedOption: selectedDate,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedDate(updatedSelection)),
      count: 0,
      colorSelected: selectedDate.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      isDateRangeFilter: true,
    },
  ];

  return (
    <Box
      sx={{ width: "100%", display: "flex", alignItems: "center" }}
      data-tracker="4"
    >
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={handleClearFilters}
      />
    </Box>
  );
}
